import React, { useState, useEffect } from "react";
import { Col, Form, Row, Button, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  Elements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { ADD_CARD, PICKUP_DROP_SAVE } from "../../../services/ApiCalls";
import logo from "../../../Assets/images/logo.png";

// Initialize Stripe with your publishable key
const stripePromise = loadStripe(
  "pk_test_51PY7pJGe0Ocl1LJYRB8p7GldIoxO4Z1BzXQyaRDFDYN52hyUhEyHz1hsNVKbaQ901WDI4bBDh3TxS53uizOEe81z00uRP2M8fF"
);

const schema = z.object({
  // Add your custom validations here
});

const Step3Form = ({
  step,
  setStep,
  selectedService,
  step1FormData,
  formData,
  step0FormData,
  step2FormData
}) => {
  console.log(step0FormData, "step0FormData", step2FormData);
  const [loader, setLoader] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  });

  const onSubmit = async (data) => {
    console.log(data, "Form Data");
    setLoader(true);

    if (!stripe || !elements) {
      toast.error("Stripe is not initialized");
      setLoader(false);
      return;
    }

    try {
      // Fetch individual card elements
      const cardNumberElement = elements.getElement(CardNumberElement);

      // Generate a token using the entered card details
      const tokenResponse = await stripe.createToken(cardNumberElement);

      if (tokenResponse.error) {
        toast.error(tokenResponse.error.message || "Card validation failed");
        setLoader(false);
        return;
      }

      const token = tokenResponse.token.id;

      // Prepare payload for ADD_CARD
      const cardData = {
        expDate: data.expDate,
        name: data.name,
        token, // Token from Stripe
        last4: tokenResponse.token.card.last4, // Last 4 digits of the card
        type: data.type,
        customerEmail: formData?.customerEmail,
      };

      // Call ADD_CARD API
      const cardResponse = await ADD_CARD(cardData);
      const cardIdNew = cardResponse?.data?.data?._id;

      if (cardResponse?.data?.status === "success") {
        const body = JSON.parse(localStorage.getItem("body"));
        const newBody = JSON.parse(localStorage.getItem("newBody"));

        const paymentBody = {
          ...body,
          ...newBody,
          customerCountryCode: step0FormData?.customerCountryCode,
          customerEmail: step0FormData?.customerEmail,
          customerMobileNumber: step0FormData?.customerMobileNumber,
          customerName: step0FormData?.customerName,
          paymentSourceRef: cardIdNew,
        };

        // Call PICKUP_DROP_SAVE API
        const paymentResponse = await PICKUP_DROP_SAVE(paymentBody);
        if (paymentResponse?.data?.status === "success") {
          toast.success(
            paymentResponse?.data?.message || "Payment successful!"
          );
          setShowModal(true)
          setTimeout(() => {
            window.location.href = step1FormData?.return_url;
          }, 5000);
        } else {
          toast.error(paymentResponse?.data?.message || "Payment failed.");
        }
      } else {
        toast.error(cardResponse?.data?.message || "Failed to add card.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoader(false);
    }
  };

  const handleClose = () => {
    setShowModal(false)
    window.location.href = step1FormData?.return_url;
  }
  return (
    <>
      {/* <div className="top py-2 d-flex align-items-center gap-10">
        <Button
          onClick={() => setStep(2)}
          className="border-0 p-0"
          variant="transparent"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22 20.418C19.5533 17.4313 17.3807 15.7367 15.482 15.334C13.5833 14.9313 11.7757 14.8705 10.059 15.1515V20.5L2 11.7725L10.059 3.5V8.5835C13.2333 8.6085 15.932 9.74733 18.155 12C20.3777 14.2527 21.6593 17.0587 22 20.418Z"
              fill="black"
              stroke="black"
              strokeWidth="2"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
        <h4 className="m-0 fw-sbold">Payment Method</h4>
      </div> */}
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col lg="12" sm="6" className="my-2">
            <div className="py-2 mb-3 text-start">
              <h5>Enter Your Payment Details</h5>
            </div>
            <div className="py-2">
              <label>Pay Amount: </label> <strong>{`$${step2FormData?.estimatedAmount}`}</strong>
            </div>
            {/* Card Number */}
            <div className="py-2">
              <label>Card Number</label>
              <CardNumberElement className="form-control" />
            </div>

            {/* Expiration Date */}
            <div className="py-2">
              <label>Expiration Date</label>
              <CardExpiryElement className="form-control" />
            </div>

            {/* CVV */}
            <div className="py-2">
              <label>CVV</label>
              <CardCvcElement className="form-control" />
            </div>

            {/* Postal Code (optional) */}
            {/* <div className="py-2">
              <label>Postal Code</label>
              <input
                type="text"
                className="form-control"
                {...register("postalCode", { required: true })}
              />
              {errors.postalCode && (
                <small className="text-danger">Postal Code is required</small>
              )}
            </div> */}

            <div className="my-2 d-flex justify-content-center mx-auto mt-4 col-lg-4">
              <Button
                onClick={() => setStep(2)}
                className="btn d-flex align-items-center justify-content-center commonBtn w-auto mx-auto"
              >
                Back
              </Button>
              <Button
                className="d-inline-flex w-auto mx-auto align-items-center justify-content-center commonBtn"
                type="submit"
                disabled={loader || !stripe || !elements}
              >
                {loader ? "Processing..." : "Pay"}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
      <Modal
        show={showModal}
        onHide={handleClose}
        size="md"
        centered
        className="vendorSignup"
      >
        <div className="rounded-5 overflow-hidden" style={{ background: "linear-gradient(324.93deg, #C11111 0.74%, #6F1010 100%)" }}>

          <Modal.Body >

            <div className="text-center">
              <div className="vendorSignup_logo mb-3">
                <img src={logo} alt="" />
              </div>
              <h6 className="text-white px-5">

                Your booking has been created successfully.

              </h6>

              <Button className="modalClose mt-4" onClick={handleClose}>
                Ok
              </Button>

            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

const Step3 = (props) => (
  <Elements stripe={stripePromise}>
    <Step3Form {...props} />
  </Elements>
);

export default Step3;
